import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../../translation/services/translation.service';

@Pipe({
  name: 'translateTo',
  pure: false
})
export class TranslateToPipe implements PipeTransform {

  // Constructor
  constructor(private _translate: TranslationService) {}

  // Transform
  transform(value: any, language: string): any {
    if (!value) { return; }
    return this._translate.translate(value, language);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/translate-to/translate-to.pipe.ts